import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { AdditionalConfigFragmentProps } from './AdditionalConfigFragment.props';
import { InputGroupWrapperBox, MultiSelectFieldWrapper, StyledTextField, StyledTypography, StyledWrapperGrid } from './AdditionalConfigFragment.styles';
import { MultiSelectCheckmarksMenu } from '../../../../components/atoms/MultiSelectCheckmarksMenu';
import { DropdownItem } from '../../../../components/atoms/SelectMenu/SelectMenu.props';
import { TypographyVariantProps } from '../../../../components/atoms/Typography';
import { SpecialServiceTasksEnum, StructureTypeCategory } from '../../../../configs/enums';
import { SPECIAL_SERVICE_TASKS } from '../../../../constants/structure';
import { useGetStructureTypesByCategoryCode } from '../../../../queries/structure-type-query';
import { filterAdditionalConfigs } from '../../../../utils/structure';

export const AdditionalConfigFragment: React.FC<AdditionalConfigFragmentProps> = ({
  nodeId,
  additonalConfig,
  setAdditonalConfig,
  isContract
}) => {
  const [structureTypeList, setStructureTypeList] = useState<DropdownItem[]>([]);
  const { data: structureTypesData } = useGetStructureTypesByCategoryCode(StructureTypeCategory.Operational);
  
  useEffect(() => {
    if (structureTypesData) {
      setStructureTypeList(structureTypesData.map((data) => (
        { value: data.code, label: data.name }
      )));
    }
  }, [structureTypesData]);
  return (
    <StyledWrapperGrid container mt={0} direction="column">
      <Grid>
        <StyledTypography variant={TypographyVariantProps.H6}>{'Additional Config'}</StyledTypography>
      </Grid>
      <Grid container>
        <Grid size={{ xs: 6 }}>
          <MultiSelectCheckmarksMenu
            id="admin-aditional-config-menu"
            label="Service Tasks"
            required={false}
            items={filterAdditionalConfigs(SPECIAL_SERVICE_TASKS, nodeId, isContract)}
            selectedValue={additonalConfig.serviceTasksConfigs?.map(serviceTask => serviceTask.code)}
            onChange={(selectedItems) => {
              if (selectedItems !== '') {
                const codes = selectedItems.split(',');
                const updatedAdditionalConfigs = additonalConfig.serviceTasksConfigs?.filter(serviceTask => codes.some(code => code === serviceTask.code));
                const newCodes = codes.filter(code => !additonalConfig.serviceTasksConfigs?.some(serviceTask => serviceTask.code === code));
                const newConfigs = newCodes.map(code => ({
                  code: code,
                  additionalData: ''
                }));
                setAdditonalConfig({ ...additonalConfig, serviceTasksConfigs: [...updatedAdditionalConfigs, ...newConfigs] });
              }
              else {
                setAdditonalConfig({ ...additonalConfig, serviceTasksConfigs: [] });
              }
            }}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <InputGroupWrapperBox>
            {
              additonalConfig.serviceTasksConfigs?.map(serviceTask => {
                return (serviceTask?.code && ![SpecialServiceTasksEnum.MultiOnSiteSuggestions, SpecialServiceTasksEnum.CreateChildrenOnCreateStructureLocation].includes(serviceTask?.code as SpecialServiceTasksEnum) &&
                (serviceTask?.code === SpecialServiceTasksEnum.StructureCreationTypes ?
                  <>
                    <MultiSelectFieldWrapper>
                      <MultiSelectCheckmarksMenu
                        id="allowable-structure-types"
                        label="Allowable Structure Types"
                        selectedValue={serviceTask.structureTypes}
                        onChange={(value) => {
                          const configDataIndex = additonalConfig.serviceTasksConfigs.findIndex(data => data.code === serviceTask.code);
                          if (configDataIndex != -1) {
                            additonalConfig.serviceTasksConfigs[configDataIndex].structureTypes = value.split(',');
                          }
                          setAdditonalConfig({ ...additonalConfig });
                        } }
                        items={structureTypeList}
                      />
                    </MultiSelectFieldWrapper>
                    <MultiSelectFieldWrapper>
                      <MultiSelectCheckmarksMenu
                        id="allowable-brand-children"
                        label="Allowable Brand Children"
                        selectedValue={serviceTask.brandChildren}
                        onChange={(value) => {
                          const configDataIndex = additonalConfig.serviceTasksConfigs.findIndex(data => data.code === serviceTask.code);
                          if (configDataIndex != -1) {
                            additonalConfig.serviceTasksConfigs[configDataIndex].brandChildren = value.split(',');
                          }
                          setAdditonalConfig({ ...additonalConfig });
                        } }
                        items={structureTypeList}
                      />
                    </MultiSelectFieldWrapper>
                  </>
                  :
                  <StyledTextField
                    fullWidth
                    key={serviceTask.code}
                    label={filterAdditionalConfigs(SPECIAL_SERVICE_TASKS, nodeId, isContract).find(task => task.value === serviceTask.code)?.additionalDataLabel}
                    value={serviceTask.additionalData}
                    onChange={(textValue) => {
                      const configDataIndex = additonalConfig.serviceTasksConfigs.findIndex(data => data.code === serviceTask.code);
                      if (configDataIndex != -1) {
                        additonalConfig.serviceTasksConfigs[configDataIndex].additionalData = textValue;
                      }
                      setAdditonalConfig({ ...additonalConfig });
                    }}
                  />
                )
                );
              })
            }
          </InputGroupWrapperBox>
        </Grid>
      </Grid>
    </StyledWrapperGrid>
  );
};